import { render, staticRenderFns } from "./editPrinterRuleMachine.vue?vue&type=template&id=0ecf1f77"
import script from "./editPrinterRuleMachine.vue?vue&type=script&lang=js"
export * from "./editPrinterRuleMachine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports